import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { IErrorModel } from '../../models/error.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class PhdsoftErrorService implements ErrorHandler {
  constructor(private readonly snackBar: MatSnackBar) { }

  public handleError(error: HttpErrorResponse | IErrorModel): IErrorModel {
    let errorMessage: IErrorModel = {};
    errorMessage = { InnerError: error, Description: 'Unknown error', Title: '👎 Unknown error' };

    switch ((error as any).status) {
      // case 503:
      // case 0:
      //   errorMessage.Title = '🔌 You are offline or unavailable service',
      //     errorMessage.Description = ``;
      //   this.snack(errorMessage.Title, errorMessage.Description);
      //   break;
      case 404:
        errorMessage.Title = '🔎 Not found - ';
        errorMessage.Description = `No data found for search criteria.`;
        console.warn(errorMessage.Title, errorMessage.Description);
        break;
      case 710:
          errorMessage.Title = '🛑 Fail to retrieve data from Database',
            errorMessage.Description = ``;
          this.snack(errorMessage.Title, errorMessage.Description);
          break;
      case 1004:
        errorMessage.Title = '🚫 Access denied - ';
        errorMessage.Description = `Login or password invalid.`;
        this.snack( errorMessage.Title, errorMessage.Description);
        break;
      default:
        console.error(error);
        break;
    }

    return errorMessage;
  }

  /**
   * Success message
   * @param message alert message
   * @param action alert text
   * @example snack('Save user', 'Operation performed successfully')
   */
  public snack(message: string, action: string): void {
    this.snackBar.open(message, action, { duration: 7000 });
  }
}
